function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.98 47.557l-.347.72v-.45c.118-.09.233-.18.346-.27zm-.347-9.358l.916-.01v10.089c-6.112 4.882-16.922 7.646-24.231 7.474-7.309-.171-18.227-2.592-24.308-7.474V38.7h.915v9.128c5.368 4.092 15.211 6.812 23.414 7.005 7.574.177 17.675-2.725 23.294-7.006v-9.628zm-47.052 9.36l.344.719v-.45c-.117-.09-.232-.179-.344-.27zm0 0l.344.719v-.45c-.117-.09-.232-.179-.344-.27zm23.758 7.274c7.574.177 17.675-2.725 23.294-7.006v-9.628l.916-.01v10.089c-6.112 4.882-16.922 7.646-24.231 7.474-7.309-.171-18.227-2.592-24.308-7.474V38.7h.915v9.128c5.368 4.092 15.211 6.812 23.414 7.005zm23.64-7.276l-.346.72v-.45c.118-.09.233-.18.346-.27z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.762 14.182L1.619 28.223l.009.914L39.76 44.758l38.082-15.623.027-.995-38.108-13.958z",
  stroke: "#371447",
  fill: "#9575CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.411 51.732h-2.44V38.45c.038-.22.043-.366.013-.439-.056-.08-.288-.275-.678-.523l-16.27-8.43 1.12-2.18 16.358 8.476.041.026c.706.442 1.196.856 1.488 1.314.335.524.438 1.158.368 1.887v13.15z",
  stroke: "#371447",
  fill: "#9575CD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.703 25.686)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.829 22.006)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.488 2.773l1.24.894c-2.334 3.268-2.7 6.968-1.088 11.192l-1.424.55c-1.79-4.692-1.37-8.934 1.272-12.636zm3.507-.043l1.52.12c-.378 4.985 1.077 7.597 4.374 8.17l-.256 1.51c-4.19-.728-6.071-4.106-5.638-9.8z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.72 3.95l1.376.66c-1.57 3.308-1.333 6.441.724 9.506l-1.265.857C2.197 11.46 1.915 7.75 3.72 3.95z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.065 3.075l1.485.35c-1.114 4.804-.353 7.716 2.165 8.97l-.676 1.373C4.76 12.135 3.807 8.493 5.065 3.075z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#9575CD",
  cx: 4.852,
  cy: 2.703,
  rx: 2.568,
  ry: 2.628
})), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#9575CD",
  cx: 6.786,
  cy: 2.396,
  rx: 6.782,
  ry: 2.113
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#371447"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.1 50.785L36.66 63.61a4.618 4.618 0 012.475 3.884l.064 1.422a2.513 2.513 0 01-3.537 2.407L8.33 59.081a4.618 4.618 0 01-2.336-6.084l.04-.091a4.403 4.403 0 016.065-2.121z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.744 65.92a4.608 4.608 0 00-1.626-2.754c-1.985-1.616-4.912-1.29-6.537.727-1.626 2.018-1.334 4.964.652 6.58 1.985 1.617 4.913 1.291 6.538-.726",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.224 63.666l4.626 2.043c2.331-2.64 4.713-3.837 7.146-3.592 1.586.328-7.492-3.706-27.235-12.1-3.492-.058-5.645 1.278-6.456 4.009.153.046 4.193 1.817 12.12 5.314",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.463 57.285l-.045-.03c-.55-.368-1.191-.755-1.457-.88a8.918 8.918 0 00-1.58-.509c-2.097-.403-4.108 1.021-4.93 3.314-.308.856-.397 1.411-.402 2.192-.001.12.001.555.001.623 0 .268-.005.494-.019.733a4.86 4.86 0 000 .46c.006.14.008.214.01.286.004.155.002.284-.008.411l-.038.15-.143.322-.072.163a5.73 5.73 0 01-3.659 3.189c.1.02.206.035.317.041.562.033.954.015 1.236-.037.131-.025.43-.12.485-.13.198-.035.37.01.557.126l.108.094c.387.46.167.936-.325 1.387a3.597 3.597 0 01-.144.124c.53.083 1.251.077 1.856-.015 1.488-.228 2.837-1.378 3.56-3.002a4.816 4.816 0 00.238-3.29l-.018-.122c-.007-.967-.002-1.385.034-1.82.152-1.86 1.572-3.259 4.438-3.78zM17.788 69.724a7.863 7.863 0 00-.065.044c.037 0 .06-.002.065-.044z",
  strokeWidth: 0.915,
  fill: "#371447"
})));

function SvgEducationLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEducationLg;